export const TUNING_STUDIO_CARD_WIDTH = 300;
export const TUNING_STUDIO_CARD_HEIGHT = 200;
